import React, { useContext, useEffect, useState } from 'react';
import { PageContext } from './provider';
import Countup from 'react-countup';
import { initConfigs } from '../context/constants';

const Footer = () => {
    const { state } = useContext(PageContext);

    const [ lastTotalSales, setLastTotalSales ] = useState(0);
    const [ lastTotalOrders, setLastTotalOrders ] = useState(0);
    const [ totalOrders, setTotalOrders ] = useState('-');
    const [ totalSales, setTotalSales ] = useState('-');

    useEffect(() => {
        // Get total orders
        setLastTotalOrders(!totalOrders || totalOrders === '-' ? 0 : totalOrders);
        const orderCount = state.ordersData.length;

        orderCount ? setTotalOrders(orderCount) : setTotalOrders('-');

        // Gen total sales
        setLastTotalSales(!totalSales || totalSales === '-' ? 0 : totalSales);
        const grandTotal = state.ordersData.reduce((accumulator, item) => {
            return accumulator + parseFloat(item.GrandTotal);
        }, 0);

        grandTotal > 0 ? setTotalSales(grandTotal.toFixed(2)) : setTotalSales('-');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ state.ordersData ]);

    return (
        <div className='footer'>
            <div className='summary'>
                <label>Orders per minute</label>
                <h1>
                    {
                        totalOrders !== '-' ? (
                            <Countup
                                duration={initConfigs.totalCountAnimateTime / 1000}
                                start={lastTotalOrders}
                                end={totalOrders}
                                decimals={0}
                                separator={','}
                            />
                        ) : totalOrders
                    }{' '}

                </h1>
            </div>
            <div className='summary'>
                <label>Sales per minute</label>
                <h1>
                    {
                        totalSales !== '-' ? (
                            <Countup
                                duration={initConfigs.totalCountAnimateTime / 1000}
                                start={lastTotalSales}
                                end={totalSales}
                                prefix={'$'}
                                decimals={2}
                                separator={','}
                            />
                        ) : totalSales
                    }{' '}
                </h1>
            </div>
        </div>
    );
};

export default Footer;
